import React from 'react';
import { validated } from 'react-custom-validation';

import { USER_ROLES, USER_ROLES_LOOKUP } from 'utils/constants';
import { isEmail, isRequired } from 'utils/validations';

import ActionMenu from 'components/ActionMenu';
import ActionMenuButton from 'components/ActionMenuButton';
import Form from 'components/Form';
import FormActionSelect from 'components/FormActionSelect';
import FormError from 'components/FormError';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Input from 'components/Input';
import ModalButton from 'components/ModalButton';
import SlideList from 'components/SlideList';

class UserEditForm extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        handleChange: React.PropTypes.func.isRequired,
        handleRoleChange: React.PropTypes.func.isRequired,
        handleGroupListEditClick: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        saveError: React.PropTypes.object,
        user: React.PropTypes.object.isRequired,
        onValid:React.PropTypes.func.isRequired,
        onInvalid:React.PropTypes.func.isRequired
    };

    render() {
        let { closeModal, handleChange, handleGroupListEditClick, handleRoleChange, isSaving, saveError, user, onValid, onInvalid, $field, $validation } = this.props;


        return (
            <Form className="user-edit__form modal-form">
                <FormRow>
                    <Input type="text"
                           name="firstName"
                           placeholder="First Name"
                           value={user.firstName}
                           {...$field('firstName', (event) => handleChange(event))}
                           onChange={handleChange.bind(this)} />
                    {$validation.firstName.show && <FormValidationMessage>{$validation.firstName.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormRow className="form-row">
                    <Input type="text"
                           name="lastName"
                           placeholder="Last Name"
                           {...$field('lastName', (event) => handleChange(event))}
                           value={user.lastName} />
                    {$validation.lastName.show && <FormValidationMessage>{$validation.lastName.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormRow className="form-row">
                    <Input type="text"
                           name="userName"
                           placeholder="Email Address"
                           {...$field('userName', (event) => handleChange(event))}
                           value={user.userName} />
                    {$validation.userName.show && <FormValidationMessage>{$validation.userName.error.reason}</FormValidationMessage>}
                </FormRow>

                <SlideList className="user-details__groups-list user-details__list"
                           count={user.department && Object.keys(user.department).length > 0 ? 1 : 0}
                           icon="groups"
                           items={user.department ? [user.department] : []}
                           showEditButton={true}
                           onEditClick={handleGroupListEditClick.bind(this)}
                           title="Groups"
                           type="groups" />

                <FormRow>
                    <FormActionSelect icon="roles"
                                      title="Role"
                                      triggerIcon="carrot-right"
                                      triggerText={USER_ROLES_LOOKUP[user.role]}>
                            <ActionMenu>
                                {Object.keys(USER_ROLES_LOOKUP).map((role, index) => {
                                    if(role !== USER_ROLES.ADMIN) {
                                        return (
                                            <ActionMenuButton type="button" onClick={handleRoleChange.bind(this, role)}
                                                              key={index}>
                                                {USER_ROLES_LOOKUP[role]}
                                            </ActionMenuButton>
                                        )
                                    } else {
                                        return null;
                                    }
                                })}
                            </ActionMenu>
                    </FormActionSelect>
                </FormRow>

                <FormError show={Object.keys(saveError).length > 0}>
                    {saveError.friendlyMessage ? saveError.friendlyMessage : saveError.message}
                </FormError>

                <div className="modal__buttons">
                    <ModalButton disabled={isSaving === true}
                                 icon="check"
                                 onClick={(event) => {
                                     event.preventDefault();
                                     this.props.$submit(onValid, onInvalid)}}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 disabled={isSaving === true}
                                 icon="cancel"
                                 onClick={closeModal.bind(this)}
                                 text="Cancel" />
                </div>
            </Form>
        )
    }
};

function userEditdFormValidationConfig(props) {
    const { firstName, lastName, userName } = props.user;
    return {
        fields: ['firstName', 'lastName', 'userName'],
        validations: {
            firstName: [
                [isRequired, firstName]
            ],
            lastName: [
                [isRequired, lastName]
            ],
            userName: [
                [isRequired, userName],
                [isEmail, userName]
            ]
        }
    }
}

export default UserEditForm = validated(userEditdFormValidationConfig)(UserEditForm);




// WEBPACK FOOTER //
// ./src/containers/UsersPage/modals/UserEditForm.js